export var OPT_IN_EVENT = "RCB/OptIn";